import { render, staticRenderFns } from "./Row.vue?vue&type=template&id=afd7b9a6&scoped=true"
import script from "./Row.vue?vue&type=script&lang=ts"
export * from "./Row.vue?vue&type=script&lang=ts"
import style0 from "./Row.vue?vue&type=style&index=0&id=afd7b9a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd7b9a6",
  null
  
)

export default component.exports